module.exports = __webpack_public_path__ + "media/images/diy/holiday_party-4c8346de73f6345f244ca64b0a2c6648.jpg";